import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { StorageHomePageModelState } from '@/models/storageHomePage';
import { ConnectState } from '@/models/connect';
import { history } from 'umi';
import { FUtil, FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import {Dispatch} from 'redux';

interface NoContentProps {
  dispatch: Dispatch;

  storageHomePage: StorageHomePageModelState;
}

function NoContent({ dispatch, storageHomePage }: NoContentProps) {

  return (<>
    <div className={styles.styles} style={{ height: 'calc(100vh - 70px)' }}>
      <div className={styles.emptyPrompt}>
        <FComponentsLib.FTipText
          text={FI18n.i18nNext.tAuto('manage_buckets_empty_title')}
          type='first'
        />
        <div style={{ height: 30 }} />
        <FComponentsLib.FTipText
          text={FI18n.i18nNext.tAuto('manage_buckets_empty_msg')}
          type='second'
        />
        <div style={{ height: 30 }} />
        <FComponentsLib.FRectBtn
          type='primary'
          size='large'
          style={{ paddingLeft: 50, paddingRight: 50 }}
          onClick={() => {
            history.replace(FUtil.LinkTo.storageSpace({
              createBucket: true,
            }));
          }}
        >{FI18n.i18nNext.tAuto('create_bucket')}</FComponentsLib.FRectBtn>
        <div style={{ height: 80 }} />
      </div>
    </div>
  </>);
}

export default connect(({ storageHomePage }: ConnectState) => ({
  storageHomePage: storageHomePage,
}))(NoContent);
